import { Card, CardContent, CardFooter, Timeline } from '@ps/isp-web-component-library';
import type { PopularAccumulatorsConfig } from '@ps/isp-web-services-types';
import React from 'react';

import { MultipleSelections } from '@swf/sports/components/Selection/MultipleSelections';
import { useNormalisedEventBasedData } from '@swf/sports/hooks/useNormalisedEventBasedData';

import PopularAccumulatorCardHeader from '../PopularAccumulatorCardHeader/PopularAccumulatorCardHeader';

import EventBasedPopularAccumulatorItem from './components/EventBasedPopularAccumulatorItem/EventBasedPopularAccumulatorItem';

interface Props {
  popularAccumulator: PopularAccumulatorsConfig;
}

const EventBasedPopularAccumulatorCard: React.FC<Props> = ({ popularAccumulator }: Props) => {
  const { markets, eventType } = useNormalisedEventBasedData({
    marketId: popularAccumulator.runnerIds[0].marketId
  });

  return (
    <Card>
      <PopularAccumulatorCardHeader
        count={popularAccumulator.count}
        eventTypeId={eventType.eventTypeId}
      />
      <CardContent>
        <Timeline>
          {popularAccumulator.runnerIds.map((runnerId) => (
            <EventBasedPopularAccumulatorItem
              key={`${runnerId.marketId}-${runnerId.selectionId}`}
              {...runnerId}
            />
          ))}
        </Timeline>
      </CardContent>
      <CardFooter>
        <MultipleSelections
          selections={popularAccumulator.runnerIds.map((runnerId) => ({
            runnerId,
            market: markets[runnerId.marketId]
          }))}
          odds={popularAccumulator.winRunnerOdds}
        />
      </CardFooter>
    </Card>
  );
};
export default EventBasedPopularAccumulatorCard;
